import React, { useEffect, useState } from 'react';
import { API, graphqlOperation } from 'aws-amplify';
import { makeStyles } from '@material-ui/core/styles';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, Paper, TextField, Button } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    boxShadow: '0px 8px 16px 0px rgba(0,0,0,0.1)',
    borderRadius: '12px',
    overflow: 'hidden',
    marginBottom: '15px',
    backgroundColor: '#f9f9f9'
  },
  tableHeader: {
    backgroundColor: '#01b5e2',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '1rem'
  },
  tableRow: {
    '&:hover': {
      backgroundColor: '#e5f7fb',
    },
  },
  tableCell: {
    padding: theme.spacing(1.5, 2),
    fontSize: '0.9rem'
  },
  filterContainer: {
    padding: theme.spacing(2),
    display: 'flex',
    gap: '10px',
    marginBottom: '20px'
  }
}));

const listCareHomes = /* GraphQL */ `
  query ListCareHomes(
    $filter: ModelCareHomesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCareHomes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        Name
        CareHome
        Type
        Category
        City
        PostCode
        LocalAuthority
        Region
        ServiceGroup
        ProviderName
        RatingCaring
        RatingEffective
        RatingResponsive
        RatingSafe
        RatingWellLed
        RatingOverall
        NHSRegion
        ReportDate
        CQCURL
      }
      nextToken
      __typename
    }
  }
`;

const CareHomes = () => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [overflow, setOverflow] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [nextToken, setNextToken] = useState(null);
  const [filters, setFilters] = useState({
    Name: '',
    CareHome: '',
    Type: '',
    Category: '',
    LocalAuthority: '',
    Region: '',
    ProviderName: ''
  });

  useEffect(() => {
    fetchCareHomes();
  }, [page]);

  const fetchCareHomes = async () => {
    let accumulatedData = [...overflow];
    let currentToken = page === 0 ? null : nextToken;
    const limit = 100;

    const filterInput = Object.keys(filters).reduce((acc, key) => {
      if (filters[key]) {
        acc[key] = { contains: filters[key] };
      }
      return acc;
    }, {});

    while (accumulatedData.length < 50) {
      const result = await API.graphql(graphqlOperation(listCareHomes, {
        filter: filterInput,
        limit: limit,
        nextToken: currentToken
      }));
      console.log(accumulatedData.length);
      if (!result.data.listCareHomes.items.length) break;
      accumulatedData = [...accumulatedData, ...result.data.listCareHomes.items];
      currentToken = result.data.listCareHomes.nextToken;
      if (!currentToken) break; // Exit if there's no more data
    }

    if (accumulatedData.length > 50) {
      setData(accumulatedData.slice(0, 50));
      setOverflow(accumulatedData.slice(50));
    } else {
      setData(accumulatedData);
      setOverflow([]);
    }
    setNextToken(currentToken);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleFilterChange = (event) => {
    setFilters({ ...filters, [event.target.name]: event.target.value });
  };

  const handleSearch = () => {
    setPage(0);
    setNextToken(null);
    setOverflow([]);
    fetchCareHomes();
  };

  return (
    <Paper className={classes.tableContainer}>
      <div className={classes.filterContainer}>
        {Object.keys(filters).map((filterKey) => (
          <TextField
            key={filterKey}
            name={filterKey}
            label={filterKey}
            value={filters[filterKey]}
            onChange={handleFilterChange}
            variant="outlined"
            size="small"
          />
        ))}
        <Button variant="contained" color="primary" onClick={handleSearch}>
          Search
        </Button>
      </div>
      <TableContainer component={Paper}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {Object.keys(data[0] || {}).map((key) => (
                <TableCell key={key} className={classes.tableHeader}>
                  {key}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row) => (
              <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                {Object.keys(row).map((key) => (
                  <TableCell key={key} className={classes.tableCell}>
                    {row[key]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[50]}
        component="div"
        count={-1} // Unknown total count
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
      />
    </Paper>
  );
};

export default CareHomes;
